import { FaBell } from "react-icons/fa";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { selectUnreadNotificationCount } from "store/user/user.selector";

/** Bell link with a dot only while there are unseen notifications. */
function NotificationBell({ className = "w-4 h-4" }: { className?: string }) {
  const unread = useSelector(selectUnreadNotificationCount);
  return (
    <Link
      to={"/dashboard/notifications"}
      className="relative"
      aria-label={unread > 0 ? `Notifications, ${unread} unread` : "Notifications"}>
      <FaBell className={className} />
      {unread > 0 && (
        <div className="w-2 h-2 border-2 border-white rounded-full bg-[#E50000] absolute -top-0.5 -right-[0.5px]"></div>
      )}
    </Link>
  );
}

export default NotificationBell;
